<template>
  <div class="login">
        <video id="headTitle" autoplay muted loop src="@/assets/video/head.webm"></video>
        <video id="ball" autoplay muted loop src="@/assets/video/login/login_bg_ball.webm"></video>

        <div class="form-box">
            <img src="@/assets/images/login/login_form_bg.png" alt="">
            <video id="loginForm" autoplay muted src="@/assets/video/login/login_form_bg.webm"></video>
            <el-form :model="form" label-width="0px" class="form">
                <el-form-item label="" prop="username">
                    <el-input  v-model="form.username" placeholder="请输入用户名" prefix-icon="el-icon-user-solid" clearable></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                    <el-input :type="type" 
                        v-model="form.password" 
                        placeholder="请输入密码" 
                        prefix-icon="el-icon-s-goods" 
                        @keyup.native="onkeyup" 
                        @keydown.native="onkeydown"
                        @blur="isFocusPW=false" 
                        @focus="isFocusPW=true">
                    </el-input>
                    <img class="pwd-icon" v-if="form.password!=''" :src="showPwd?require('@/assets/images/login/hide.png'):require('@/assets/images/login/show.png')" @click="pwdChange" alt="">
                </el-form-item>

                <!-- 账号密码错误提示 -->
                <div v-if="errorMsg!=null" class="error-tip">
                    <img src="@/assets/images/login/error.png" alt="">
                    <span>{{errorMsg}}</span>
                </div>

                <!-- 大小写锁定提示 -->
                <div v-if="isFocusPW && bigChar" class="caps-lock">
                    <img src="@/assets/images/login/hint.png" alt="">
                    <span>大小写锁定已打开</span>
                </div>

                <el-form-item class="btn">
                    <el-button type="primary" @click="submitForm" :loading="loading">登&nbsp; &nbsp;&nbsp;录</el-button>
                </el-form-item>
            </el-form>
        </div> 

        <div class="copyright">
            <video id="decoarate" autoplay muted loop src="@/assets/video/login/bottom.webm"></video>
            <div>Copyright © 2012-{{year}} 成都比昂科技有限公司 . All Rights Reserved.</div>
        </div>    
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "login",
  data() {
    return {
        year:'',
        form: {
          username:'',
          password: '',
        },
        type:'password',
        showPwd:false,
        loading:false,
        errorMsg:null,

        bigChar: false,
        shifKey: undefined,
        isFocusPW: false
    };
  },
  watch:{
    showPwd(val){
        if(!val){
            this.type='password'
        }else {
            this.type='text'
        }
    }
  },
  computed: {},

  created() {},
  mounted() {
    // 获取当前年份
    this.year=moment().format("YYYY")

    window.addEventListener('keydown', (event) => {
      let e = event || window.event
      //  检测大写锁定键
      if (e.keyCode === 20) {
        if (!this.isFocusPW) {
          this.bigChar = !this.bigChar
        }
      }
    })

  },
  methods: {
    // 密码显示与隐藏
    pwdChange(){
        this.showPwd=!this.showPwd
    },

    onkeyup (event) {
        const _that = this
        // 判断是否按键为caps Lock
        if (event.keyCode === 20) {
            _that.bigChar = !_that.bigChar
            return
        }
        // 按键不是caps Lock，判断每次最后输入的字母的大小写
        let e = event || window.event 
        let keyvalue = e.keyCode ? e.keyCode : e.which
        let shifKey = _that.shifKey
        if (typeof (_that.userPassword) === 'undefined') return
        let userPassword = _that.userPassword
        let strlen = userPassword.length

        if (strlen) {
            let uniCode = userPassword.charCodeAt(strlen - 1)
            // 65到90字母键
            if (keyvalue >= 65 && keyvalue <= 90) {
            // 是否同时按住shift键
            if (((uniCode >= 65 && uniCode <= 90) && !shifKey) || ((uniCode >= 97 && uniCode <= 122) && shifKey)) {
                _that.bigChar = true
            } else {
                _that.bigChar = false
            }
            }
        }
    },
    onkeydown (event) {
        let e = event || window.event
        let keyvalue = e.keyCode ? e.keyCode : e.which
        let shifKey = e.shiftKey ? e.shiftKey : ((keyvalue === 16))
        this.shifKey = shifKey
    },

    submitForm() {
        // if(this.form.username==''){
        //     this.errorMsg='请输入用户名'
        //     return
        // }
        // if(this.form.password==''){
        //     this.errorMsg='请输入密码'
        //     return
        // }
        // this.loading = true
        // login(this.form).then(res=>{
        //     // console.log(res,"登录")
        //     if(res.code==200){
        //         this.errorMsg=null
        //         setTimeout(()=>{
        //             this.loading = false
        //             this.$router.push({path:'/page'})
        //         },800)
        //     }else{
        //         // this.errorMsg='用户名或密码错误,请重新输入!'
        //         this.errorMsg=res.msg
        //         this.loading = false
        //     }
        // }).finally(() => {
        //     this.loading = false
        // })

        if(this.form.username == 'penglai'&&this.form.password == '123456'){
            this.errorMsg=null
            setTimeout(()=>{
                this.loading = false
                this.$router.push({path:'/page'})
            },1000)
        }else{
          this.errorMsg='用户名或密码错误,请重新输入!'
          this.loading = false
        }     
    },
  },
};
</script>

<style lang="less" scoped>
.login {
    width: 100%;
    height: 100%;
    background: url("~@/assets/images/login/login_bg.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    position: relative;
    #headTitle{
        width: 100%;
        margin: -90px 0 -120px 0;
    }
    #ball{
        width: 100%;
        height: 969px;
    }

    .form-box{
        width: 369px;
        height: 393px;
        position: absolute;
        top: 37%;
        right: 200px;
        >img{
            width: 335px;
            height: 355px;
            position: absolute;
            top: 20px;
            left: 20px;
        }
        #loginForm{
            height: 393px;
        }

        /deep/.form{
            position: absolute;
            top: 130px;
            left: 45px;
            width: 276px;
            height: 230px;
            .el-form-item{
                position: relative;
                margin-bottom: 16px;
                // .el-input{
                    .el-input__inner{
                        background: rgba(12, 51, 64, 0.8);
                        border: 1px solid rgba(41, 148, 194, 1);    
                        padding: 20px 40px;
                        background-clip: content-box;
                        color: rgba(255, 255, 255, 0.8);
                        letter-spacing: 1px;
                        font-size: 14px;
                        font-weight: 700;
                    
                    }          
                    .el-input__inner::placeholder {
                        color: rgba(255, 255, 255, 0.4);
                    }
                 
                // }
            }
            .pwd-icon{
                width: 16px;
                position: absolute;
                top: 50%;
                right: 12px;
                transform: translateY(-50%);
                cursor: pointer;
            }
            
            // 账号密码错误提示
            .error-tip{
                margin-top: -10px;
                border-radius: 2px;
                background: rgba(78, 19, 19, 0.8);
                border: 1px solid rgba(238, 32, 19, 1); 
                padding: 2px 6px;
                display: flex;
                align-items: center;
                >img{
                    width: 12px;  
                }
                span{
                    margin-left: 6px;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.8);
                }
            }

            .caps-lock{
                margin-top: 3px;
                border-radius: 2px;
                background: rgba(79, 36, 19, 0.8);
                border: 1px solid rgba(237, 121, 19, 1);      
                padding: 2px 6px;
                display: flex;
                align-items: center;
                >img{
                    width: 12px;  
                }
                span{
                    margin-left: 6px;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.8);
                }
            }
            .btn{
                width: 100%;
                position: absolute;
                bottom: 10px;
                .el-button{
                    width: 100%;
                    margin-top: 30px;
                    border-radius: 2px;
                    background: linear-gradient(129.66deg, rgba(46, 192, 255, 0.8) 0%, rgba(27, 196, 247, 0.8) 100%);
                    border: 1px solid rgba(41, 158, 194, 1);    
                    font-size: 16px;
                    font-weight: 700;
                    color: rgba(255, 255, 255, 1); 
                
                }
            }
        }
    } 

    .copyright{
        position: absolute;
        bottom: 10px;
        #decoarate{
            width: 1873px;
            margin-left: 23px;
        }
        >div{
            width: 100%;
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            position: absolute;
            bottom: 30px;
        }
    }
}
</style>
